import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-cream-dark" data-id="element-193">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        type: 'spring',
        bounce: 0.4
      }} className="flex flex-col items-center" data-id="element-195">
          {/* CSS Seal */}
          <div className="relative w-44 h-44 mb-8 flex items-center justify-center" data-id="element-196">
            <div className="absolute inset-0 bg-sage-700 rounded-full flex items-center justify-center shadow-xl" data-id="element-197">
              <div className="absolute inset-2 border-2 border-dashed border-sage-100/50 rounded-full" data-id="element-198"></div>
              <div className="flex flex-col items-center text-cream" data-id="element-199">
                <ShieldCheck size={40} className="mb-1" data-id="element-200" />
                <span className="font-bold text-lg leading-none tracking-wider" data-id="element-201">
                  GARANTÍA
                </span>
                <span className="text-sm font-medium tracking-widest mt-1" data-id="element-202">
                  30 DÍAS
                </span>
              </div>
            </div>
            {/* Decorative outer ring */}
            <div className="absolute inset-[-10px] border border-sage-700/20 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-203"></div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-204">
            Garantía de Riesgo Cero
          </h2>

          <p className="text-lg text-charcoal-light leading-relaxed max-w-2xl" data-id="element-205">
            Prueba el programa por{' '}
            <strong className="text-sage-700" data-id="element-206">30 días completos</strong>. Si
            sientes que la información no es para ti, o no resuena con lo que
            necesitas, te devolvemos el 100% de tu dinero.{' '}
            <strong className="text-sage-700 font-semibold" data-id="element-207">
              Sin preguntas. Sin complicaciones.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}